<div class="payment-page">
  <div class="payment-container">
    <div class="payment-header">
      <span class="section-tag">Checkout</span>
      <h1 class="page-title">Complete your purchase</h1>
      <p class="page-subtitle">Pay securely with 200+ cryptocurrencies via NOWPayments</p>
    </div>

    <div class="payment-grid">
      <!-- Order summary -->
      <div class="order-summary">
        <h2>Order summary</h2>
        <div class="summary-row" *ngIf="selectedPackage">
          <div>
            <div class="summary-name">{{ selectedPackage.name }} Package</div>
            <div class="summary-credits">{{ selectedPackage.credits }} credits</div>
          </div>
          <div class="summary-price">${{ selectedPackage.price }}</div>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-row">
          <span>Subtotal</span>
          <span class="mono">${{ selectedPackage?.price || 0 }}</span>
        </div>
        <div class="summary-row">
          <span>Processing fee</span>
          <span class="mono">$0.00</span>
        </div>
        <div class="summary-divider"></div>
        <div class="summary-row summary-total">
          <span>Total</span>
          <span class="mono">${{ selectedPackage?.price || 0 }}</span>
        </div>
      </div>

      <!-- Payment -->
      <div class="payment-method">
        <h2>Payment method</h2>
        <p class="payment-info">You'll be redirected to NOWPayments to complete your purchase. We support 200+ cryptocurrencies including BTC, ETH, USDT, and more.</p>

        <div class="crypto-icons">
          <span class="crypto-icon" title="Bitcoin">₿</span>
          <span class="crypto-icon" title="Ethereum">Ξ</span>
          <span class="crypto-icon" title="USDT">₮</span>
          <span class="crypto-icon" title="Litecoin">Ł</span>
        </div>

        <div *ngIf="errorMessage" class="payment-error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <span>{{ errorMessage }}</span>
        </div>

        <button class="btn btn-primary btn-xl payment-btn" (click)="initiatePayment()" [disabled]="isProcessing || !selectedPackage">
          <span class="spinner spinner-sm" *ngIf="isProcessing"></span>
          <span>{{ isProcessing ? 'Redirecting...' : 'Pay with crypto' }}</span>
        </button>

        <p class="payment-secure">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Secured by NOWPayments. We never store your payment details.
        </p>
      </div>
    </div>
  </div>
</div>
